"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

require("./IconElement.css");

var horizontalAlignment = {
  display: 'inline-flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center'
};
var verticalAlignment = {
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  display: 'inline-flex',
  flexDirection: 'column'
};

var IconElement = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(IconElement, _React$Component);

  function IconElement() {
    (0, _classCallCheck2["default"])(this, IconElement);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(IconElement).apply(this, arguments));
  }

  (0, _createClass2["default"])(IconElement, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconType = _this$props.iconType,
          iconSize = _this$props.iconSize,
          iconPosition = _this$props.iconPosition,
          element = _this$props.element,
          className = _this$props.className;
      var horizontal = iconPosition === 'left' || iconPosition === 'right';
      var elementFirst = iconPosition === 'right' || iconPosition === 'bottom';
      return _react["default"].createElement("div", {
        className: "ie-base-class ".concat(horizontal && 'ie-horiz', " ").concat(className),
        style: horizontal ? horizontalAlignment : verticalAlignment
      }, elementFirst && element, _react["default"].createElement(_semanticUiReact.Icon, {
        name: iconType,
        size: iconSize
      }), !elementFirst && element);
    }
  }]);
  return IconElement;
}(_react["default"].Component);

exports["default"] = IconElement;
IconElement.propTypes = {
  className: _propTypes["default"].string,
  element: _propTypes["default"].element,
  iconPosition: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
  iconSize: _propTypes["default"].oneOf(['big', 'large', 'huge']),
  iconType: _propTypes["default"].string
};
IconElement.defaultProps = {
  className: '',
  element: _react["default"].createElement("h2", null, "Sample Element"),
  iconPosition: 'left',
  iconSize: 'large',
  iconType: 'phone'
};